import styled from "styled-components";

import { Button, from, Option, Text } from "@runwayhealth/runway-components-react";

const ConditionContent = `  
  display: flex;
  align-items: center;
  height: 100%;
  background: white;
  gap: 8px;
  min-width: 250px;
  width: 100%;
`;

export const ConditionOption = styled(Option)`
  ${ConditionContent}
  label {
    padding: 5px 15px 4px 20px !important;
  }
  @media ${from.mobileS} {
    margin-bottom: 5px;
  }
  @media (max-width: 374px) {
    .option-label {
      max-width: 120px;
    }
  }

  @media (min-width: 375px) and (max-width: 415px) {
    .option-label {
      max-width: 150px;
    }
  }

  @media (min-width: 416px) {
    .option-label {
      max-width: none;
    }
  }

  div[variant="radio"] {
    margin-top: 18px;
    margin-bottom: 19px;
  }
`;

export const ConditionCard = styled.div`
  ${ConditionContent}
  border: 1px solid #95b6fb;
  border-radius: 13px;
  border-width: 2px;
  padding: 8px 12px 4px 12px;
  min-width: 280px;
  width: 100%;
  @media ${from.desktop} {
    margin-bottom: 5px;
    width: 45%;
  }
`;

export const CardInfoWrapper = styled.div<{ $inlineInfo?: boolean }>`
  display: flex;
  width: 100%;
  justify-content: center;
  flex-direction: column;
  ${(props) => (props.$inlineInfo ? "margin-left: 15px;" : null)};
`;

export const TitleWrapper = styled.div<{ $infoButtonInline?: boolean }>`
  text-align: left;
  display: flex;
  align-items: center;

  ${(props) =>
    props.$infoButtonInline
      ? `  
      justify-content: space-between;
    `
      : null};
`;

export const DescriptionWrapper = styled.div<{ $infoButtonInline?: boolean }>`
  text-align: left;
  display: flex;
  align-items: flex-start;
  flex-direction: ${(props) => (props.$infoButtonInline ? "row" : "column")};
  ${(props) =>
    props.$infoButtonInline
      ? `  
      justify-content: space-between;
    `
      : null};
`;

export const TextWrapper = styled.div<{ $infoButtonInline?: boolean }>`
  display: flex;
  ${(props) =>
    props.$infoButtonInline
      ? `
  justify-content: space-around;
  gap: 4px;
  @media (max-width: 321px) {
    flex-direction: column;
  }
  `
      : "width: 179px"};
  align-items: center;
  .info-button-wrapper {
    padding-left: 5px;
  }
`;

export const OptionElementWrapper = styled.div`
  display: flex;
  justify-content: space-betweem;
  gap: 5px;
  align-items: center;
`;

export const ConditionText = styled(Text)<{ $reducedWeight?: boolean; $hasDiscount?: boolean }>`
  ${(props) => (props.$reducedWeight ? "font-weight: 200;" : "font-weight: 700;")};
  ${(props) => (props.$reducedWeight ? "font-size: 13px;" : "font-size: 1rem;")};
  margin-bottom: 1px;
  ${(props) =>
    props.$hasDiscount &&
    `    
      text-decoration: line-through;
      text-align: end;
      padding-right: 10px;
      color: gray;
    `}
`;

export const ConditionActionButton = styled(Button)`
  border-width: 0px;
  box-shadow: none;
  width: 20px;
  height: 20px;
`;

export const InfoButton = styled(Button)`
  margin-top: 0px !important;
  margin-bottom: 0px !important;
  border-width: 0px;
  box-shadow: none;
  color: #96b6fa;
  width: 20px;
  height: 20px;
`;
